import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Database, FileText } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-white py-20 px-4 md:px-8 border-y border-gray-200" data-id="element-99">
      <div className="max-w-5xl mx-auto text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-101">
          <span className="text-gold font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-102">
            The Unique Mechanism
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-8" data-id="element-103">
            The "Neighborhood Leveling" Method
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-16" data-id="element-104">
            This system isn't based on emotional pleas; it's based on cold data
            the County cannot ignore.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-105">
          {[{
          icon: <Database className="w-12 h-12 text-navy" data-id="element-106" />,
          title: 'Government Data',
          desc: "We teach you how to use the government's own database to find 'Unfair Comparables'."
        }, {
          icon: <Scale className="w-12 h-12 text-navy" data-id="element-107" />,
          title: 'Irrefutable Evidence',
          desc: 'By presenting evidence that similar homes in your area are taxed less, you legally force the assessor to reconsider your number.'
        }, {
          icon: <FileText className="w-12 h-12 text-navy" data-id="element-108" />,
          title: 'The Ultimate Weapon',
          desc: "It's a data fight, and with this manual, you have the best weapons to win your case."
        }].map((feature, i) => <motion.div key={i} className="flex flex-col items-center text-center p-8 rounded-2xl bg-cream border border-gray-100 shadow-sm" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.6
        }} data-id="element-109">
              <div className="w-20 h-20 bg-gold/20 rounded-full flex items-center justify-center mb-6" data-id="element-110">
                {feature.icon}
              </div>
              <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-111">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-112">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}